import { menuAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(menuAnatomy.keys);

const baseStyle = definePartsStyle({
  button: {
    color: "text.primary",
  },
  item: {
    fontWeight: "normal",
    _hover: {
      textDecoration: "none",
    },
  },
});

export default defineMultiStyleConfig({ baseStyle });
